import { render, staticRenderFns } from "./HomeSwiper.vue?vue&type=template&id=1601a334&"
import script from "./HomeSwiper.vue?vue&type=script&lang=js&"
export * from "./HomeSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HomeSwiper.vue"
export default component.exports